import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import trackfocus from "../../../../assets/images/docs/debugtools/track-focus.mp4";
import * as React from 'react';
export default {
  BlogMidCTA,
  trackfocus,
  React
};